export default __webpack_public_path__ + "static/media/Manuscripts2.4a3f3e05.png";